﻿export interface IPhoneNumber {
    id: number;
    isDeleted: boolean;
    phoneTypeId: number;
    phoneTypeName: string;
    number: string;
    mobileProviderId: number;
    mobileProviderName: string;
    contactId: number;
}

export interface IPhoneNumberForEdit extends IPhoneNumber {
    edit: boolean
}